import { render, staticRenderFns } from "./ManagePages.vue?vue&type=template&id=07f75121"
import script from "./ManagePages.vue?vue&type=script&lang=js"
export * from "./ManagePages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports